import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { first } from 'rxjs/operators';

import { EmailDomainCustomizationFlags } from '../config/email-domain.config';
import { EmailDomainCustomizationService } from '../services/email-domain-customization.service';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[emailDomainCustomization]'
})

/**
 * @description EmailDomainCustomizationDirective: hides elements based on the user's email domain, can be enhanced for other features.
 * @param {ViewContainerRef} viewContainerRef A reference to the angular viewContainer.
 * @param {TemplateRef} templateRef Angular embedded template.
 * @param {EmailDomainCustomizationService} emailDomainCustomizationService Service used to access user data.
 */
export class EmailDomainCustomizationDirective {

	constructor(
		private viewContainerRef: ViewContainerRef,
		private templateRef: TemplateRef<any>,
		private emailDomainCustomizationService: EmailDomainCustomizationService
	) { }

	@Input() public set emailDomainCustomization(value: EmailDomainCustomizationFlags) {
		if (value) {
			this.updateView(value);
		}
	}

	private updateView(feature: EmailDomainCustomizationFlags): void {
		// Check if the feature is enabled for firm of current user , hide the feature.
		// this directive can be enhanced for other firm/email domain based customizations in the future
		this.emailDomainCustomizationService.isFeatureEnabledOnFirm(feature).pipe(first()).subscribe(featureEnabled => {
			if (featureEnabled) {
				this.viewContainerRef.clear();
			}
			else {
				this.viewContainerRef.createEmbeddedView(this.templateRef);
			}
		});
	}
}

